import { render, staticRenderFns } from "./WorkflowFormBuilderConstraintsTab.vue?vue&type=template&id=965a0aca&"
import script from "./WorkflowFormBuilderConstraintsTab.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderConstraintsTab.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowFormBuilderConstraintsTab.vue?vue&type=style&index=0&id=965a0aca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports